import {Channel} from "./channels.model";
import {CacheKey, Deserializer, JsonProperty, ObjectMapper, Serializer} from "json-object-mapper";

export class DecisionsModel {

  @JsonProperty({name: "channel", type: Channel})
  public channel: Channel;

  @JsonProperty({name: "algorithm"})
  public algorithm: string;

  @JsonProperty({name: "status"})
  public status: string;

  @JsonProperty({name: "created"})
  public created: number;

  @JsonProperty({name: "updated"})
  public updated: number;

}

export class EvaluationExpectation {

  @JsonProperty({name: "mean"})
  public mean?: number = undefined;

  @JsonProperty({name: "deviation"})
  public deviation?: number = undefined;
}

@CacheKey("EvaluationExpectationSerializerDeserializer")
export class EvaluationExpectationSerializerDeserializer implements Deserializer, Serializer {
  deserialize = (value: Object): EvaluationExpectation => {
    if (value) {
      return ObjectMapper.deserialize(EvaluationExpectation, value);
    } else {
      return new EvaluationExpectation();
    }
  }
  serialize = (value?: EvaluationExpectation): Object => {
    return ObjectMapper.serialize(value);
  }
}

export class ModelEvaluationExpectations {
  @JsonProperty({name: "true_positive", type: EvaluationExpectation, deserializer: EvaluationExpectationSerializerDeserializer})
  public truePositive?: EvaluationExpectation = undefined;

  @JsonProperty({name: "false_positive", type: EvaluationExpectation, deserializer: EvaluationExpectationSerializerDeserializer})
  public falsePositive?: EvaluationExpectation = undefined;

  @JsonProperty({name: "true_negative", type: EvaluationExpectation, deserializer: EvaluationExpectationSerializerDeserializer})
  public trueNegative?: EvaluationExpectation = undefined;

  @JsonProperty({name: "false_negative", type: EvaluationExpectation, deserializer: EvaluationExpectationSerializerDeserializer})
  public falseNegative?: EvaluationExpectation = undefined;

}

@CacheKey("ModelEvaluationExpectationsSerializerDeserializer")
export class ModelEvaluationExpectationsSerializerDeserializer implements Deserializer, Serializer {
  deserialize = (value: Object): ModelEvaluationExpectations => {
    if (value) {
      return ObjectMapper.deserialize(ModelEvaluationExpectations, value);
    } else {
      return new ModelEvaluationExpectations();
    }
  }
  serialize = (value?: ModelEvaluationExpectations): Object => {
    return ObjectMapper.serialize(value);
  }
}

export class ModelEvaluationResults {

  @JsonProperty({name: "total"})
  public total?: number = undefined;

  @JsonProperty({name: "positive"})
  public positive?: number = undefined;

  @JsonProperty({name: "correct"})
  public correct?: number = undefined;

  @JsonProperty({name: "positive_true"})
  public positiveTrue?: number = undefined;

  @JsonProperty({name: "positive_false"})
  public positiveFalse?: number = undefined;

  @JsonProperty({name: "negative_true"})
  public negativeTrue?: number = undefined;

  @JsonProperty({name: "negative_false"})
  public negativeFalse?: number = undefined;

  public getTruePositive() {
    if (this?.positiveTrue == undefined || this?.positive == undefined || this?.positive == 0.0) {
      return 0.0;
    } else {
      return this?.positiveTrue / this?.positive;
    }
  }

  public getFalsePositive() {
    if (this?.positiveFalse == undefined || this?.positive == undefined || this?.positive == 0.0) {
      return 0.0;
    } else {
      return this?.positiveFalse / this?.positive;
    }
  }

}

@CacheKey("ModelEvaluationResultsSerializerDeserializer")
export class ModelEvaluationResultsSerializerDeserializer implements Deserializer, Serializer {
  deserialize = (value: Object): ModelEvaluationResults => {
    if (value) {
      return ObjectMapper.deserialize(ModelEvaluationResults, value);
    } else {
      return new ModelEvaluationResults();
    }
  }
  serialize = (value?: ModelEvaluationResults): Object => {
    return ObjectMapper.serialize(value);
  }
}

export class ModelEvaluation {
  @JsonProperty({name: "batch"})
  public batch?: string = undefined;

  @JsonProperty({name: "channel", type: Channel})
  public channel?: Channel = undefined;

  @JsonProperty({name: "contour"})
  public contour?: string = undefined;

  @JsonProperty({name: "status"})
  public status?: string = undefined;

  @JsonProperty({name: "created"})
  public created?: number = undefined;

  @JsonProperty({name: "results", type: ModelEvaluationResults, deserializer: ModelEvaluationResultsSerializerDeserializer})
  public results?: ModelEvaluationResults = undefined;

  @JsonProperty({name: "expectations", type: ModelEvaluationExpectations, deserializer: ModelEvaluationExpectationsSerializerDeserializer})
  public expectations?: ModelEvaluationExpectations = undefined;
}

@CacheKey("ModelEvaluationsSerializerDeserializer")
export class ModelEvaluationsSerializerDeserializer implements Deserializer, Serializer {
  deserialize = (value: Object): ModelEvaluation => {
    if (value) {
      return ObjectMapper.deserialize(ModelEvaluation, value);
    } else {
      return new ModelEvaluation();
    }
  }
  serialize = (value?: ModelEvaluation): Object => {
    return ObjectMapper.serialize(value);
  }
}

@CacheKey("ArrayModelEvaluationsSerializerDeserializer")
export class ArrayModelEvaluationsSerializerDeserializer implements Deserializer, Serializer {
  deserialize = (values: Object[]): ModelEvaluation[] => {
    return values.map(v => {
      try {
        return ObjectMapper.deserialize(ModelEvaluation, v);
      }
      catch(e) {
        console.log(e);
        return new ModelEvaluation();
      }

    })
  }
  serialize = (values: ModelEvaluation[]): Object[] => {
    return values.map(v => {
      return ObjectMapper.serialize(v);
    })
  }
}
